import { AbstractModel } from '../../shared/abstract.model';

/**
 * Favorite class, describe storage object for persisted state
 */
export class Favorite extends AbstractModel {
  /**
   * Username
   */
  public userId: string;
  /**
   * Favorite name
   */
  public name: string;
  /**
   * Persisted MapState
   */
  public state: string;

  public global: boolean;

  constructor() {
    super();
    this.id = null;
  }
}
